import { useId } from "react";
import { TextFieldProps, TextField as TextFieldUi } from "@mui/material";

type TextFieldProp = TextFieldProps & { name?: string; width?: number | string };

export const TextField = ({ width, name, id, ...other }: TextFieldProp) => {
  const generatedId = useId();

  return (
    <div style={{ width: width }}>
      <TextFieldUi {...other} id={id ?? generatedId} name={name} />
    </div>
  );
};